<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
            :columns="['QUADRO', 'COLUNA', 'TAG', $lang.Common.DataTable.Actions]"
            :showNew="true"
            :showSearch="true"
            :showReload="true"
            :showTipFooter="false"
            v-on:New="onNew"
            v-on:Load="onLoad"
            v-on:Reload="onLoad"
            v-on:Search="onShowSearch">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsTextNoLink="true" :value="obj.boardNome ? obj.boardNome.toUpperCase() : ''" :status="1" />
        <TableColumn :IsTextNoLink="true" :value="obj.boardColumnNome ? obj.boardColumnNome.toUpperCase() : 'TODAS AS COLUNAS'" :status="1" />
        <td class="text-center" style="font-size: 11px;">
          <span v-if="obj.tagNome">
            {{ obj.tagNome.toUpperCase() }}
          </span>
          <span v-else class="text-muted">-</span>
        </td>
        <TableColumn :IsActionsButtons="true" :HasChange="false" v-on:Delete="onDelete(obj)" :status="obj.status || 1" />
      </tr>
    </Tables>
    <SidebarSearch ref="SidebarSearch" @search="onSearch" />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import SidebarSearch from '../../search/SidebarTagAssign.vue'
import TagQuadroColunaRepository from '@/shared/http/repositories/configurations/tag-quadro-coluna.js'

export default {
  name: 'TagAssignSection',
  mixins: [ActionsForm],
  components: {
    SidebarSearch
  },
  data () {
    return {
      filters: {},
      isSearching: false // Flag para controlar se é uma pesquisa ou carregamento inicial
    }
  },
  methods: {
    onNew () {
      // Emite evento para abrir o modal
      this.$emit('open-modal')
    },
    onShowSearch () {
      // Abre a sidebar de pesquisa de atribuir tags usando o ref
      if (this.$refs.SidebarSearch && this.$refs.SidebarSearch.show) {
        this.$refs.SidebarSearch.show()
      } else {
        // Fallback: usa o evento do Bootstrap Vue
        this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
      }
    },
    onSearch (filters) {
      // Se filters for null ou undefined, é limpeza de filtros - volta a mostrar todos
      if (filters === null || filters === undefined) {
        this.filters = {}
        this.isSearching = false // Não é pesquisa, é limpeza - mostra todos
        this.onLoad()
        return
      }

      // Verifica se é um objeto vazio
      if (!filters || Object.keys(filters).length === 0) {
        this.filters = {}
        this.isSearching = false
        this.onLoad()
        return
      }

      // Verifica se há pelo menos um filtro com valor válido
      const hasAnyFilter = (filters.quadroId != null && filters.quadroId !== '' && filters.quadroId !== undefined) ||
                          (filters.tagId != null && filters.tagId !== '' && filters.tagId !== undefined)

      if (hasAnyFilter) {
        // Marca que é uma pesquisa (não carregamento inicial)
        this.isSearching = true
        this.filters = { ...filters } // Cria uma cópia para evitar referência
      } else {
        // Filtros vazios - trata como limpeza
        this.filters = {}
        this.isSearching = false
      }
      this.onLoad()
    },
    onLoad () {
      loading.push()
      // Prepara os filtros para enviar ao backend
      // Garante que apenas valores numéricos válidos sejam enviados
      const filters = {}

      // Valida e converte quadroId para boardId
      if (this.filters.quadroId != null && this.filters.quadroId !== '' && this.filters.quadroId !== undefined) {
        const quadroIdNum = Number(this.filters.quadroId)
        if (!isNaN(quadroIdNum) && quadroIdNum > 0) {
          filters.boardId = quadroIdNum
        }
      }

      // Valida e converte colunaId para boardColumnId
      // Só adiciona se também tiver quadroId (coluna depende do quadro)
      if (filters.boardId && this.filters.colunaId != null && this.filters.colunaId !== '' && this.filters.colunaId !== undefined) {
        const colunaIdNum = Number(this.filters.colunaId)
        if (!isNaN(colunaIdNum) && colunaIdNum > 0) {
          filters.boardColumnId = colunaIdNum
        }
      }

      // Valida e converte tagId
      if (this.filters.tagId != null && this.filters.tagId !== '' && this.filters.tagId !== undefined) {
        const tagIdNum = Number(this.filters.tagId)
        if (!isNaN(tagIdNum) && tagIdNum > 0) {
          filters.tagId = tagIdNum
        }
      }

      // Só valida filtros se for uma pesquisa (não carregamento inicial)
      // Se for carregamento inicial sem filtros, traz todos os dados normalmente
      if (this.isSearching) {
        const hasValidFilters = filters.boardId || filters.tagId

        if (!hasValidFilters) {
          loading.pop()
          toast.warning('Informe pelo menos um filtro (Quadro ou Tag) para pesquisar', 'Atenção')
          // Limpa a grid quando não há filtros válidos na pesquisa
          const emptyResponse = {
            status: 200,
            data: {
              content: [],
              totalElements: 0,
              totalPages: 0,
              number: 0
            }
          }
          this.onResultGrid(emptyResponse, this.$refs.tableGrid)
          this.isSearching = false // Reseta a flag
          return
        }
      }

      // Garante valores padrão para paginação
      const limit = (this.$refs.tableGrid && this.$refs.tableGrid.pagingLimit) || 10
      const index = (this.$refs.tableGrid && this.$refs.tableGrid.pagingIndex !== undefined && this.$refs.tableGrid.pagingIndex !== null) ? this.$refs.tableGrid.pagingIndex : 0

      TagQuadroColunaRepository.GetAllPaging(
        limit,
        index,
        filters
      )
        .then((response) => {
          this.onResultGrid(response, this.$refs.tableGrid)
        })
        .catch((err) => {
          this.onException(err)
        })
        .finally(() => {
          // Sempre reseta a flag após processar (sucesso ou erro)
          this.isSearching = false
        })
    },
    onDelete (obj) {
      // Monta a mensagem considerando se é coluna específica ou todas as colunas
      const colunaTexto = obj.boardColumnNome ? `coluna "${obj.boardColumnNome.toUpperCase()}"` : 'todas as colunas'
      const mensagem = `Deseja excluir a vinculação da tag "${obj.tagNome.toUpperCase()}" com o quadro "${obj.boardNome.toUpperCase()}"${obj.boardColumnNome ? `, ${colunaTexto}` : ` (${colunaTexto})`}?`

      this.$bvModal.msgBoxConfirm(
        mensagem,
        {
          title: 'Confirmar Exclusão',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )
        .then(value => {
          if (value) {
            loading.push()
            TagQuadroColunaRepository.Delete(obj.id)
              .then((response) => {
                loading.pop()
                toast.success('Vinculação removida com sucesso!')
                this.onLoad()
              })
              .catch(this.onException)
          }
        })
        .catch(err => {
          void err
          // An error occurred
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/board/tag/components/assign/TagAssignSection.vue